import React, { forwardRef } from "react";
import "./printKOT.css"
import { getCurrentLocale } from "../../i18n/locale";
import { useTranslation } from "react-i18next";

const PrintKot = forwardRef(({ items = [], bill, liveOrderKot = false }, ref) => {
  const { t } = useTranslation();
  const today = new Date();
  console.log("print kot",items)
  console.log("print bill",bill)
  return (
    <div ref={ref} className="receipt">
      {/* <h3>KOT : {bill?.tokenNumber || bill?.orderNumber}</h3> */}
      {bill?.tableNumber && <p>{t("Table No.")}: {bill?.tableNumber}</p>}
      <p>
        {new Intl.DateTimeFormat(getCurrentLocale(), {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }).format(today)}
      </p>
      <hr />

      <table className="receipt-table">
        <thead>
          <tr>
            <th>{t("Item")}</th>
            <th>{t("Qty")}</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(items) && items.map((item, i) => (
            <tr key={i}>
             <td className="food-cell">
                  <span className="food-name">{item.foodName}</span>

                  {Array.isArray(item.selectedAddons) && item.selectedAddons.length > 0 && (
        <div style={{ color: "#6b7280", fontSize: "11px", marginTop: "2px" }}>
          {t("Add-ons")}:
          {item.selectedAddons.map((addon, idx) => (
            <div key={addon.addonItemId || idx}>
               {addon.itemName} (+₹{addon.price})
            </div>
          ))} 
        </div>
      )} <div style={{ color: "#6b7280", display: "block", fontSize: "12px" }}>{item.addonSummary}</div>
                  {/* <small style={{ color: "#6b7280", display: "block", fontSize: "12px" }}>
                                {item.addonSummary}
                  </small> */}
                  
                 {item.note && <span className="note-text">{t("Note:")} {item.note}</span>}
             </td>
              <td>{liveOrderKot ? item.qty :  item.selected}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <hr />
      <p>*** {t("Kitchen Copy")} ***</p>
    </div>
  );
});

export default PrintKot;
